import { Loader2 } from "lucide-react";

export const LoadingScreen = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
  </div>
);
